module.exports = __webpack_public_path__ + "img/1440.b7e4b4b0.jpg";